module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"diving-porpoise\"-in-pomona-california-23e9e84c3914a640529cf68c2c8fd6fe.png";